import { ALP_URL, PRODUCT_URL } from 'constants/links';
import { FeatureFlagProps } from './_components/customer-account/types';
import { getSeoUrl } from 'utils/links';
import { Params } from 'next/dist/shared/lib/router/utils/route-matcher';
import { PriceAvailabilityResponseHeadless } from 'services/priceAvailability/types';
import { transformPriceAndAvailabilityHeadless } from 'services/dealerPriceAvailability/utils';
import {
  GA_FORM_INVALID_SERIAL,
  GA_INVALID_SERAIL_SITES
} from './_constants/constants';
import { HP_BUY_AGAIN_GA_LIST_NAME } from './_components/customer-account/buy-again/constants';

export const getFormatedSeoUrl = (seoUrl: string, params: Params) => {
  const { esite, lang } = params;
  return seoUrl.replace(`/${lang}/${esite}`, '');
};

export const navigateToSeoUrl = (
  featureFlag: FeatureFlagProps,
  seoUrl: string,
  params: Params,
  partNumber: string
) => {
  const formattedSeoUrl = getFormatedSeoUrl(seoUrl, params);
  const alpUrl = featureFlag.PCC_HEADLESS_ASSET_LANDING_PAGE
    ? `${ALP_URL}${formattedSeoUrl}`
    : formattedSeoUrl;
  const pdpUrl =
    partNumber && featureFlag.PCC_Headless_PDPEMURGE
      ? `${PRODUCT_URL}/${partNumber}`
      : alpUrl;
  const url = getSeoUrl(params, pdpUrl);
  return url;
};

export const getGaEventPriceDetails = (
  product: Product,
  pricePromise: PriceAvailabilityResponseHeadless
) => {
  const { partNumber } = product;
  const priceData =
    pricePromise &&
    transformPriceAndAvailabilityHeadless(pricePromise, partNumber);
  const gaEventproductPricePromise = {
    ...product,
    ...(pricePromise && {
      productPriceData: {
        availability: priceData.item.availability,
        quantity: priceData.item.quantity,
        weight: priceData.item.weight,
        categoryPath: product.categoryPath,
        currency: priceData.currency,
        unformattedTotalPrice: priceData.item.price.unformattedTotalPrice
      }
    })
  };

  return gaEventproductPricePromise;
};

export const getGaEventPriceDetail = (
  product,
  pricePromise,
  gaEventDetails
) => {
  const productPrice = getGaEventPriceDetails(product, pricePromise);
  const gaEventproductPricePromise = {
    productPrice,
    listNameAndId: gaEventDetails.listNameAndId
  };

  return gaEventproductPricePromise;
};

export const sendGAInvalidSerialWithSites = (appName, fireEvent) => {
  {
    const siteData = () => {
      if (appName.value === GA_INVALID_SERAIL_SITES.visionLinkAppReference) {
        return GA_INVALID_SERAIL_SITES.visionLinkSiteValue;
      } else return GA_INVALID_SERAIL_SITES.qrCodeAppReference;
    };

    return fireEvent({
      formContent2: siteData(),
      ...GA_FORM_INVALID_SERIAL
    });
  }
};

export const showDetails = (
  isLoggedIn,
  isPCCUpdatePDPCTAToSeaPartsEnabled,
  getCSPAndIAVaildUser,
  isSoftwareEnableAttachmentPart
) => {
  return (
    isLoggedIn &&
    isPCCUpdatePDPCTAToSeaPartsEnabled &&
    getCSPAndIAVaildUser &&
    isSoftwareEnableAttachmentPart
  );
};

export const shouldDisplayPriceData = (
  totalPrice,
  hasReplacement,
  isShowRequestServiceCTA,
  isSoftwareEnableAttachmentPart,
  isRegistrationPendingApproval
) => {
  return (
    !!totalPrice &&
    !hasReplacement &&
    !isShowRequestServiceCTA &&
    !isSoftwareEnableAttachmentPart &&
    !isRegistrationPendingApproval
  );
};

export const recentlyViewContactDealerCtaEnabled = (
  showAddCart,
  hasReplacement,
  isShowRequestServiceCTA,
  isIndirectReplacement,
  getCSPAndIAVaildUser,
  isSoftwareEnableAttachmentPart,
  isLoggedIn
) => {
  return (
    (!showAddCart &&
      ((!hasReplacement && !isShowRequestServiceCTA) ||
        isIndirectReplacement ||
        (!getCSPAndIAVaildUser && isSoftwareEnableAttachmentPart) ||
        (!isLoggedIn && isSoftwareEnableAttachmentPart))) ||
    (!isShowRequestServiceCTA &&
      isSoftwareEnableAttachmentPart &&
      !hasReplacement)
  );
};

export const shouldDisplayContactYourDealers = (
  gaEventDetails,
  buyAgainContactDealerCtaEnable,
  recentlyViewContactDealerCtaEnable
) => {
  return gaEventDetails.listNameAndId === HP_BUY_AGAIN_GA_LIST_NAME
    ? buyAgainContactDealerCtaEnable
    : recentlyViewContactDealerCtaEnable;
};

export const productsPriceData = (
  isRegistrationPendingApproval,
  priceData,
  product
) => {
  return !isRegistrationPendingApproval
    ? priceData?.item
    : {
        partNumber: product.partNumber,
        name: product.name,
        quantity: 1,
        sosCode: ''
      };
};
